<nav class="navbar navbar-expand-lg navbar-light">
  <div class="container">
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarTogglerDemo01"
      aria-controls="navbarTogglerDemo01"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <img
      src="assets/imgs/icons/logo.svg"
      class="logo_responsive"
      routerLink="/merchant/home"
      width="70px"
    />

    <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
      <div class="mr-3 ml-3"></div>

      <!-- <div class="position_search ">
        <form class=" form_search " #f="ngForm" (ngSubmit)="search(f.value)">
          <input class="form-control" type="text" name="search" [(ngModel)]="word"
            placeholder="{{'SEARCH' | translate}}" aria-label="Search" fs20>
          <button mat-raised-button type="submit">
            <img src="assets/imgs/icons/search_icon.svg" class="img_icon">
          </button>
        </form>
      </div> -->

      <ul class="navbar-nav">
        <!-- <li class="nav-item" *ngIf="token">
          <p class="link" routerLink="/user/wishlist">
            <span>
              {{'Wishlist'|translate}}
            </span>
            <img src="assets/imgs/icons/star_wish.svg" width="20px">
          </p>
        </li> -->

        <!-- <li class="nav-item" *ngIf="token">
          <p class="link" routerLink="/user/home">
            <span>
              {{'Bogo Offers'|translate}}
            </span>
            <img class="ml-2" src="assets/imgs/icons/categories.svg" width="20px">
          </p>
        </li> -->

        <!-- <li class="nav-item" *ngIf="token">
          <p class="link" routerLink="/plus">
            <span>
              {{'Plus Deals'|translate}}
            </span>
            <img src="assets/imgs/icons/offers.svg" width="20px">
          </p>
        </li> -->

        <li
          class="row login_btn nav-item log-btns dropdown align-items-center"
          *ngIf="!token"
        >
          <!-- <button mat-stroked-button (click)="clickToggleLogin('loginUser_card_id', $event)">
            {{'Login as a user'|translate}}
            <img src="assets/imgs/icons/arrow_down.svg">
          </button> -->

          <!-- <div class="dropdown-menu card_hover_login" id="loginUser_card_id"
            (mouseleave)="clickToggleLogin('loginUser_card_id', $event)" style="left:-20%">
            <div class="row mx-0">
              <div class="col-md-12">
                <div fs14 class="text-center mb-3 mt-2 header">{{'Login as a user'|translate}}</div>
                <form [formGroup]="UserLoginRequest" (ngSubmit)="requestLogin(UserLoginRequest.value)">
                  <div class="form-group">
                    <label for="exampleInputEmail1" fs14>{{'Phone Number'|translate}}</label>
                    <input type="text" class="form-control" formControlName="phone">

                    <div
                      *ngIf="UserLoginRequest.get('phone').invalid && (UserLoginRequest.get('phone').dirty || UserLoginRequest.get('phone').touched)"
                      class="alert alert-danger">
                      <div class="mb-0" *ngIf="UserLoginRequest.get('phone').errors.required">
                        {{'Phone Number is required.' | translate}}
                      </div>
                      <div class="mb-0" *ngIf="UserLoginRequest.get('phone').errors.pattern">
                        {{'Invalid Phone Number format.' | translate}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group" *ngIf="isOTPRequested">
                    <label for="exampleInputPassword1" fs14>{{'OTP'|translate}}</label>
                    <input type="text" class="form-control" formControlName="otp">
                    <div
                      *ngIf="UserLoginRequest.get('otp').invalid && (UserLoginRequest.get('otp').dirty || UserLoginRequest.get('otp').touched)"
                      class="alert alert-danger">
                      <div class="mb-0" *ngIf="UserLoginRequest.get('otp').errors.required">
                        {{'OTP is required.' | translate}}</div>
                    </div>
                  </div>

                  <div class="flex_link row mx-0 justify-content-between align-items-center">
                    <mat-checkbox fs12>
                      {{'Remember Me'|translate}}
                    </mat-checkbox>

                    <a routerLink="/forgot-password" fs12>{{'Forgot your password?' |translate}}</a>
                  </div>

                  <div class="mb-2" *ngIf="isOTPRequested">
                    <button mat-raised-button type="bbbtn mb-2"
                      (click)="resendSMS()">{{ 'Resend SMS' | translate }}</button>
                  </div>

                  <button mat-raised-button type="submit" fs14 class="w-100">{{'LOGIN'|translate}}</button>
                </form>
                <div class="row my-2 justify-content-center">
                  <div class="text-center header px-2" fs14>{{"Don't have an account"|translate}}</div>
                  <div class="text-center header pointer sign" fs14 routerLink="/register">{{'SIGN UP'|translate}}</div>
                </div>
              </div>
            </div>
          </div> -->

          <!-- <button
            mat-stroked-button
            (click)="clickToggleLogin('login_card_id', $event)"
          >
            {{ "Login as a merchant" | translate }}
            <img src="assets/imgs/icons/arrow_down.svg" />
          </button> -->

          <!-- <div
            class="dropdown-menu card_hover_login"
            (click)="$event.stopPropagation()"
            id="login_card_id"
            (mouseleave)="clickToggleLogin('login_card_id')"
            style="left: 20%"
          >
            <div class="row mx-0">
              <div class="col-md-12">
                <div fs14 class="text-center mb-3 mt-2 header">
                  {{ "Login as a merchant" | translate }}
                </div>
                <form
                  [formGroup]="LoginForm"
                  (ngSubmit)="login('login_card_id')"
                >
                  <div class="form-group">
                    <label for="exampleInputEmail1" fs14>{{
                      "Email address" | translate
                    }}</label>
                    <input
                      type="email"
                      class="form-control"
                      id="username"
                      formControlName="username"
                    />

                    <div
                      *ngIf="
                        username.invalid && (username.dirty || username.touched)
                      "
                      class="alert alert-danger"
                    >
                      <div class="mb-0" *ngIf="username.errors.required">
                        {{ "Email is required." | translate }}
                      </div>
                      <div class="mb-0" *ngIf="username.errors.pattern">
                        {{ "Invalid email format." | translate }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="exampleInputPassword1" fs14>{{
                      "Password" | translate
                    }}</label>
                    <input
                      type="password"
                      class="form-control"
                      id="password"
                      formControlName="password"
                    />

                    <div
                      *ngIf="
                        password.invalid && (password.dirty || password.touched)
                      "
                      class="alert alert-danger"
                    >
                      <div class="mb-0" *ngIf="password.errors.required">
                        {{ "Password is required." | translate }}
                      </div>
                      <div
                        class="mb-0"
                        *ngIf="
                          !password.errors.required &&
                          !password.errors.minLength
                        "
                      >
                        {{
                          "Password must be at least 6 characters." | translate
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="flex_link row mx-0 justify-content-between">
                    <mat-checkbox fs12>
                      {{ "Remember Me" | translate }}
                    </mat-checkbox>
                  </div>

                  <button mat-raised-button type="submit" fs14>
                    {{ "LOGIN" | translate }}
                  </button>
                </form>
              </div>
            </div>
          </div> -->
        </li>

        <li class="login_btn nav-item" *ngIf="token">
          <div class="dropdown">
            <button
              class="btn dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{ user?.name }}
            </button>
            <div class="dropdown-menu p-2" aria-labelledby="dropdownMenuButton">
              <!-- <p class="link" routerLink="/profile">
                {{ "Profile" | translate }}
              </p>
              <p class="link my-2" routerLink="/user/packages">
                {{ "Packages" | translate }}
              </p>
              <hr /> -->
              <button mat-stroked-button class="w-100" (click)="logOut()">
                {{ "Logout" | translate }}
              </button>
            </div>
          </div>
        </li>

        <li class="nav-item mr-3 ml-3" *ngIf="token">
          <!-- <div class="dropdown pointer">
            <img
              src="assets/imgs/icons/alart.svg"
              id="notification"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            />
            <div
              class="dropdown-menu p-2 notification"
              aria-labelledby="notification"
            >
              <ng-container *ngFor="let item of notifications">
                <ng-container
                  *ngIf="
                    item._type == 'flashNotification' ||
                    item._type == 'packageOffer' ||
                    item._type == 'offerNotification'
                  "
                >
                  <div class="list-item">
                    <img
                      *ngIf="item._type == 'flashNotification'"
                      src="assets/imgs/icons/offers-active.svg"
                      alt=""
                      padding-top-lg
                    />
                    <img
                      *ngIf="
                        item._type == 'packageOffer' ||
                        item._type == 'offerNotification'
                      "
                      src="assets/imgs/icons/categories-active.svg"
                      alt=""
                      padding-top-lg
                    />
                    <h4 class="title" fs16>{{ item.text }}</h4>
                  </div>
                </ng-container>

                <ng-container *ngIf="item._type == 'packageNotification'">
                  <div class="list-item">
                    <img
                      src="assets/imgs/icons/package.svg"
                      alt=""
                      padding-top-lg
                    />
                    <h4 class="title" fs16>{{ item.text }}</h4>
                  </div>
                </ng-container>

                <ng-container *ngIf="item._type == 'brandNotification'">
                  <div class="list-item">
                    <img
                      src="assets/imgs/icons/categories-active.svg"
                      alt=""
                      padding-top-lg
                    />
                    <h4 class="title" fs16>{{ item.text }}</h4>
                  </div>
                </ng-container>
              </ng-container>
              <hr />
              <button
                mat-stroked-button
                class="w-100"
                routerLink="/user/notifications"
              >
                {{ "Notifications" | translate }}
              </button>
            </div>
          </div> -->
        </li>

        <li class="nav-item mr-3 ml-3">
          <label class="switch_toggle">
            <span class="tx" [class.span_ar]="lang == 'ar'">AR</span>
            <input
              type="checkbox"
              [checked]="lang == 'en'"
              (change)="changeLang($event)"
            />
            <span class="slider round"></span>
          </label>
        </li>
      </ul>
    </div>
    <div
      class="modal fade"
      id="logOutModal"
      tabindex="-1"
      aria-labelledby="logOutModal"
      aria-hidden="true"
    >
      <div class="modal-dialog no-border">
        <div class="modal-content no-border">
          <div class="modal-body p-4">
            <h4 class="title" fs20>
              {{ "Are you sure you want to continue?" | translate }}
            </h4>
          </div>
          <div class="modal-footer">
            <button type="button" mat-stroked-button data-dismiss="modal">
              {{ "Cancel" | translate }}
            </button>
            <button
              type="button"
              class="btn btn-primary mx-2 logOut-btn"
              (click)="logOut()"
              data-dismiss="modal"
            >
              {{ "Logout" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
